




















































































import { Component, Prop, Vue } from "vue-property-decorator";
import FileOpen from "@/commonComponents/fileOpen/fileOpen.vue";
import SelectPattern from "./selectPattern/selectPattern.vue";

import SelectTextBalloon from "./selectTextBalloon/selectTextBalloon.vue";
import SelectPatternBalloon from "./selectPatternBalloon/selectPatternBalloon.vue";
import SelectLineBalloon from "./selectLineBalloon/selectLineBalloon.vue";
import SelectCodeBalloon from "./selectCodeBalloon/selectCodeBalloon.vue";
import Export from "./export/export.vue";
import Profile from "./profile/profile.vue";
import SelectSaveStorageModal from "@/commonComponents/alertModal/selectSaveStorageModal/selectSaveStorageModal.vue";
import Relate from "./relate/relate.vue";

import SelectImage from "./selectImage/selectImage.vue";
import SelectLine from "./selectLine/selectLine.vue";
import SelectCode from "./selectCode/selectCode.vue";
import SettingTable from "./settingTable/settingTable.vue";

import * as def from "@/definitions";
import { Const } from '@/const'
import { NameHelper } from "@/helper/nameHelper";

// TODO document2
import { Design } from "@/model/document2/page/surface/design/design";
import { Layer } from "@/model/document2/page/surface/design/layer/layer";
import { GroupLayer } from "@/model/document2/page/surface/design/layer/groupLayer";
import { RasterImageLayer } from "@/model/document2/page/surface/design/layer/rasterImageLayer";
import { VectorImageLayer } from "@/model/document2/page/surface/design/layer/vectorImageLayer";
import { PlainTextLayer } from "@/model/document2/page/surface/design/layer/plainTextLayer";
import { SimpleTextLayer } from "@/model/document2/page/surface/design/layer/simpleTextLayer";
import { CircleTextLayer } from '@/model/document2/page/surface/design/layer/circleTextLayer';
import { D3TextLayer } from '@/model/document2/page/surface/design/layer/d3TextLayer';
import { DateTextLayer } from '@/model/document2/page/surface/design/layer/dateTextLayer';
import { LineLayer } from "@/model/document2/page/surface/design/layer/lineLayer";
import { CurveLayer } from "@/model/document2/page/surface/design/layer/curveLayer";
import { TableLayer } from "@/model/document2/page/surface/design/layer/tableLayer";
import { BarcodeLayer } from "@/model/document2/page/surface/design/layer/barcodeLayer";
import { QRcodeLayer } from "@/model/document2/page/surface/design/layer/qrcodeLayer";

import { RectangleLayer } from "@/model/document2/page/surface/design/layer/rectangleLayer";
import { CircleLayer } from "@/model/document2/page/surface/design/layer/circleLayer";
import { PolygonLayer } from "@/model/document2/page/surface/design/layer/polygonLayer";
import { SpecialPatternLayer } from "@/model/document2/page/surface/design/layer/specialPatternLayer";
import { CalendarLayer } from "@/model/document2/page/surface/design/layer/calendarLayer";

import { Data } from "@/data/data";
import { Image } from "@/data/image/image"

//requestHelper
import { RequestHelper } from "@/helper/requestHelper";
import { FileHelper } from "@/helper/fileHelper";
import { ImageHelper } from "@/helper/imageHelper";

//ズームバー用のモジュール
import { UndoRedoManager } from "@/utilityModels/undoRedoManager";

//各ボタン
import SaveButton from "./resources/saveButton.vue";
import ExportButton from "./resources/export.vue";
import TextButton from "./resources/textButton.vue";
import ImageButton from "./resources/imageButton.vue";
import PatternButton from "./resources/patternButton.vue";
import LineButton from "./resources/lineButton.vue";
import CodeButton from "./resources/codeButton.vue";
import TableButton from "./resources/tableButton.vue";
import SerialNumberButton from "./resources/serialNumberButton.vue";
import RelateButton from "./resources/relateButton.vue";
import ProfileButton from "./resources/profileButton.vue";
import UndoButtonOn from "./resources/undoButtonOn.vue";
import RedoButtonOn from "./resources/redoButtonOn.vue";
import ZoomMinusButton from "./resources/zoomMinusButton.vue";
import ZoomValue from "./resources/zoomValue.vue";
import ZoomPlusButton from "./resources/zoomPlusButton.vue";
import AutomaticMode from "./resources/automaticMode.vue";
import Automatic from "./resources/automatic.vue";
import RotateSurfaceButton from "./resources/rotateSurfaceButton.vue";
import CalendarButton from "./resources/calendarButton.vue";

import { ResourceHelper } from "@/helper/resourceHelper"
import { UserAgentHelper } from '@/helper/userAgentHelper';
import { DebugHelper } from "@/helper/debugHelper";

import { ProfileData } from "@/utilityModels/profileData";

import { putRecentImage } from '@/data/items-recent';
import digest from '@/helper/digest';
import RangeSlider from '@/components/VRangeSliderZoom.vue';

function pickExtensionForMimeType(type: string): string {
    switch (type) {
        case 'image/svg+xml':
        case 'image/svg-xml':
            return 'svg';
        default:
            // ラスタライズが必要かどうかわかればいいのであとは適当で
            return 'png';
    }
}

@Component({
  components: {
    FileOpen,
    RangeSlider,
    SelectPattern,
    SelectLine,
    SelectCode,
    SettingTable,
    SelectImage,
    SelectTextBalloon,
    SelectPatternBalloon,
    SelectLineBalloon,
    SelectCodeBalloon,

    SaveButton,
    ExportButton,
    TextButton,
    ImageButton,
    PatternButton,
    LineButton,
    CodeButton,
    TableButton,
    SerialNumberButton,
    RelateButton,
    ProfileButton,
    UndoButtonOn,
    RedoButtonOn,
    ZoomMinusButton,
    ZoomValue,
    ZoomPlusButton,
    AutomaticMode,
    Automatic,
    RotateSurfaceButton,
    CalendarButton,

    Export,
    Profile,
    SelectSaveStorageModal,
    Relate
  }
})
export default class TopController extends Vue {
    @Prop()
    private design!: Design;
    @Prop()
    private isReverseSurface!: boolean;
    @Prop()
    private zoomScale!: number;
    @Prop()
    private isAutoZoom!: boolean;
    @Prop()
    private canUndo! : boolean;
    @Prop()
    private canRedo! : boolean;

    private get zoomMin() { return Const.CANVAS_ZOOM_MIN; }
    private get zoomMax() { return Const.CANVAS_ZOOM_MAX; }

    private get isElectron()
    {
        return UserAgentHelper.isElectron();
    }

    private get flowMode(): number
    {
        return this.$store.getters.applicationState.flowMode;
    }

    // アンドゥリドゥ管理クラス取得
    private get undoRedoManager(): UndoRedoManager {
        return this.design.undoRedoManager;
    }

    // モーダル
    private showSelectPattern: boolean = false;
    private showSelectLine: boolean = false;
    private showSelectCode: boolean = false;
    private showSettingTable: boolean = false;
    private selectStorageModalShown: boolean = false;

    isExportVisible = false;
    isProfileVisible = false;
    isSelectTextVisible = false;
    isSelectPatternVisible = false;
    isSelectLineVisible = false;
    isSelectCodeVisible = false;
    isSelectImageVisible = false;
    isRelateVisible = false

    isAutomaticMode = false;

    private static readonly ZOOM_SCALE_MIN = Const.CANVAS_ZOOM_MIN;
    private static readonly ZOOM_SCALE_MAX = Const.CANVAS_ZOOM_MAX;
    private static readonly ZOOM_SCALE_DELTA = 25;

    private get isFirefox() {
        return UserAgentHelper.getBrowser() === "firefox"
    }

    // スライダー
    private get zoomScaleSliderValue() {
        return this.zoomScale;
    }
    private set zoomScaleSliderValue(zoomScaleSliderValue) {
        this.onDoCommand("changeZoomScale", {
            scale: zoomScaleSliderValue,
            isAutoZoomOff: true
        });
    }

    private get isDebugMode(){
        return DebugHelper.isDebugMode;
    }

    private onDoCommand(command: string, paramater: any) {
        this.$emit("doCommand", command, paramater);
    }

    // 書き出し
    private onExport(parameter)
    {
        this.$emit("doCommand", "exportDesign", parameter);
    }

    // ドキュメントの保存
    private onClickSaveBottom()
    {
        this.$emit("doCommand", "saveDocument");
    }

    // 表裏切り替え
    private onClickDisplaySurface() {
        this.$emit("doCommand", "changeSurface", { isReverse: false });
    }

    private onClickDisplayBack() {
        this.$emit("doCommand", "changeSurface", { isReverse: true });
    }

    // 回転
    private onClickRotateDesign() {
        this.$emit("doCommand", "rotateDesign", { delta: 90 });
    }

    // プロフィール挿入
    private insertProfile(data : ProfileData)
    {
        this.$emit("doCommand", "insertProfile", { data : data });
    }

    // プロフィールボタンクリック
    private onClickProfile()
    {
        // テキストの編集を確定する
        this.$emit("doCommand", "fixText");
        // ショートカット無効
        this.$emit("doCommand", "enableShortcut", { isEnable : false });
        // 表示
        this.isProfileVisible = true;
    }

    // プロフィール閉じる
    private onCloseProfile()
    {
        // ショートカット有効
        this.$emit("doCommand", "enableShortcut", { isEnable : true });
        // 非表示
        this.isProfileVisible = false;
    }

    private onClickInsertObjectButton(object: string): void {
        if (object == "text") {
            var width = Math.min(this.design.width / 2, this.design.height / 2);
            var height = width;
            var x = 0;
            var y = 0;
            var plainTextLayer = PlainTextLayer.create("", x, y, width, height);
            // 名前
            plainTextLayer.name = NameHelper.createLayerName(
                "plaintext",
                this.design
            );
            var group = this.design.layer as GroupLayer;

            // 新規レイヤー作成コマンド呼び出し
            this.$emit("doCommand", "newLayer", {
                newLayer: plainTextLayer,
                parent: group
            });
        } else if (object == "image") {
            // イメージ
            // ダイアログを開いて読み込む
            var fileOpen = this.$refs.fileOpen as FileOpen;
            fileOpen.open();
        } else if (object == "pattern") {
            // 図形
            // 図形選択を表示する
            this.showSelectPattern = true;
        } else if (object == "line") {
            // 線
            // 線選択を表示する
            this.showSelectLine = true;
        } else if (object == "code") {
            // コード
            // コード選択を表示する
            this.showSelectCode = true;
        } else if (object == "table") {
            // 表
            // 表設定を表示する
            this.showSettingTable = true;
        }
        else if(object == "calendar")
        {
            // カレンダー
            // 位置とサイズ
            var width = Math.min(this.design.width * 0.8, this.design.height * 0.8);
            var height = width;
            var x = (this.design.width - width) / 2;
            var y = (this.design.height - height) / 2;
            var group = this.design.layer as GroupLayer;
            var newCalendarLayer = CalendarLayer.create(x, y, width, height);
            // 名前
            newCalendarLayer.name = NameHelper.createLayerName("calendar", this.design);
            // 新規レイヤー作成コマンド呼び出し
            this.$emit("doCommand", "newLayer", { newLayer: newCalendarLayer, parent: this.getParentGroupLayer()});
        }
        else if(object == "serialNumber")
        {
            // 連番レイヤー作成
            // 位置とサイズ
            var width = Math.min(this.design.width / 2, this.design.height / 2);
            var height = width;
            var x = (this.design.width - width) / 2;
            var y = (this.design.height - height) / 2;
            // 名前
            var name = NameHelper.createLayerName(
                "number",
                this.design
            );
            var group = this.design.layer as GroupLayer;
            this.$emit("doCommand", "createNumberLayer",{
                parent : group,
                layerName : name,
                x : x,
                y : y,
                width : width,
                height : height
            });
        }
    }

    // 挿入先のグループレイヤーを取得する
    private getParentGroupLayer() {
        // 基本はデザインのトップ
        var parent = this.design.layer as GroupLayer;
        if (this.design.currentLayer != null) {
            if (this.design.currentLayer instanceof GroupLayer) {
                // カレントがグループの場合はそのレイヤー
                parent = this.design.currentLayer;
            } else {
                // カレントがある場合はその親レイヤー
                var parentOfCurrent = this.design.getParentLayer(
                this.design.currentLayer
                );
                if (parentOfCurrent != null) {
                parent = parentOfCurrent;
                }
            }
        }
        return parent;
    }

    // TODO CanvasWindowとTopControllerにもう一つさらにあるのでDesignEditorにまとめて置きたい
    // 画像読み込みが行われた
    onImageSelected(
        imageBase64: string,
        imageWidth: number,
        imageHeight: number,
        mimeType: string,
        imageBase64WhiteTransparent : string
    ): void {
        // 画像サイズが0の場合は作らない。
        if (imageWidth <= 0 || imageHeight <= 0) {
            return;
        }

        // FIXME 条件をどっかにまとめたい
        if (UserAgentHelper.getBrowser() !== 'ie') {
            // 最近使った項目に記録する
            const image = new Image();
            image.id = digest(imageBase64);
            image.name = 'no name';
            image.imagePath = `untitled.${pickExtensionForMimeType(mimeType)}`;
            image.imageData = imageBase64;
            image.recentUsedAt = Date.now();
            putRecentImage(image);
            // 画面を更新する
            this.$store.state.data.createImageList('create');
        }

        // 読み込み処理イベントを投げる
        this.$emit("doCommand", "importImage", {
            image: imageBase64,
            imageWhiteTransparent: imageBase64WhiteTransparent,
            width : imageWidth,
            height : imageHeight,
            isSvg : mimeType == "image/svg+xml" || mimeType == "image/svg-xml"
        });
        this.isSelectImageVisible = false;
    }

    // テキスト選択
    private onSelectText(type: string) {
        var layer;
        if (type == "plainText") {
            // 通常文字レイヤー作成
            var width = Math.min(this.design.width / 2, this.design.height / 2);
            var height = width;
            var x = (this.design.width - width) / 2;
            var y = (this.design.height - height) / 2;
            layer = PlainTextLayer.create("", x, y, width, height);
            // 名前
            layer.name = NameHelper.createLayerName("plaintext", this.design);
        } else if (type == "circleText") {
            // 円周文字レイヤー作成
            var width = Math.min(this.design.width, this.design.height);
            var height = width;
            var x = (this.design.width - width) / 2;
            var y = (this.design.height - height) / 2;
            layer = CircleTextLayer.create("", x, y, width, height);
            // 名前
            layer.name = NameHelper.createLayerName("circletext", this.design);
            }
            else if(type == "d3Text")
        {
            // 3D文字レイヤー作成
            var width = Math.min(this.design.width, this.design.height);
            var height = width;
            var x = (this.design.width - width) / 2;
            var y = (this.design.height - height) / 2;
            layer = D3TextLayer.create("", x, y, width, height);
            // 名前
            layer.name = NameHelper.createLayerName(
                "d3text",
                this.design
            );
        }
        else if(type == "dateText")
        {
            // 日付文字レイヤー作成
            var width = Math.min(this.design.width, this.design.height);
            var height = width;
            var x = (this.design.width - width) / 2;
            var y = (this.design.height - height) / 2;
            layer = DateTextLayer.create(x, y, width, height);
            // 名前
            layer.name = NameHelper.createLayerName(
                "datetext",
                this.design
            );
        }
        else if(type == "simpleText")
        {
            // シンプルテキストレイヤー作成
            var width = Math.min(this.design.width / 2, this.design.height / 2);
            var height = width;
            var x = (this.design.width - width) / 2;
            var y = (this.design.height - height) / 2;
            layer = SimpleTextLayer.create("", x, y, width, height);
            // 名前
            layer.name = NameHelper.createLayerName("simpleText", this.design);
        }
        if (layer != null) {
            var parent = this.getParentGroupLayer();
            // 新規テキストレイヤー作成コマンド呼び出し
            this.$emit("doCommand", "newTextLayer", { newLayer: layer, parent: parent });
        }
    }

    // 図形選択が行われた
    onSelectPattern(pattern: number, cornerNumber: number, specialPatternType : string = "") {
        // 図形レイヤー作成
        var width = Math.min(this.design.width / 2, this.design.height / 2);
        var height = width;
        var x = (this.design.width - width) / 2;
        var y = (this.design.height - height) / 2;

        var layer: Layer | null = null;
        if (pattern == 0) {
            // 矩形
            layer = RectangleLayer.create(x, y, width, height);
            layer.name = NameHelper.createLayerName("rectangle", this.design);
        } else if (pattern == 1) {
            // 円
            layer = CircleLayer.create(x, y, width, height);
            layer.name = NameHelper.createLayerName("circle", this.design);
        } else if (pattern == 2 || pattern == 3 || pattern == 4 || pattern == 5) {
            // 多角形
            // 0: 矢印, 1:星, 3~: 凸多角形
            var cn = cornerNumber;
            if (pattern == 4) {
                cn = 0;
            } else if (pattern == 3) {
                cn = 1;
            } else if (pattern == 2) {
                cn = 3;
            }
            layer = PolygonLayer.create(cn, true, x, y, width, height);
            layer.name = NameHelper.createLayerName("polygon", this.design);
        }
        else if (pattern == 6)
        {
            // 特殊図形レイヤー
            layer = SpecialPatternLayer.create(specialPatternType, true, x, y, width, height);
            layer.name = NameHelper.createLayerName(specialPatternType, this.design);
        }

        if (layer != null) {
            var parent = this.getParentGroupLayer();
            // 新規レイヤー作成コマンド呼び出し
            this.$emit("doCommand", "newLayer", { newLayer: layer, parent: parent });
        }
    }

    // 線選択が行われた
    onSelectLine(type: string) {
        if (type == "line") {
            // 直線レイヤー作成
            var width = Math.min(this.design.width / 2, this.design.height / 2);
            var height = width;
            var x = (this.design.width - width) / 2;
            var y = (this.design.height - height) / 2;
            // 左上 -> 右下 方向に作成する
            var lineLayer = LineLayer.create(x, y, x + width, y + height);
            // 名前
            lineLayer.name = NameHelper.createLayerName("line", this.design);
            var parent = this.getParentGroupLayer();
            // 新規レイヤー作成コマンド呼び出し
            this.$emit("doCommand", "newLayer", {
                newLayer: lineLayer,
                parent: parent
            });
        } else if (type == "curve") {
            // 曲線レイヤー作成
            var width = Math.min(this.design.width / 2, this.design.height / 2);
            var height = width;
            var x = (this.design.width - width) / 2;
            var y = (this.design.height - height) / 2;
            // 初期制御点
            var x1 = x;
            var y1 = y;
            var x2 = x + width / 2;
            var y2 = y + height;
            var x3 = x + width;
            var y3 = y;
            var curveLayer = CurveLayer.create(x1, y1, x2, y2, x3, y3);
            // 名前
            curveLayer.name = NameHelper.createLayerName("curve", this.design);
            var parent = this.getParentGroupLayer();
            // 新規レイヤー作成コマンド呼び出し
            this.$emit("doCommand", "newLayer", {
                newLayer: curveLayer,
                parent: parent
            });
        }
    }

    // コード選択が行われた
    onSelectCode(type: string) {
        if (type == "qrcode") {
            // QRコード作成
            var width = Math.min(this.design.width / 2, this.design.height / 2);
            var height = width;
            var x = (this.design.width - width) / 2;
            var y = (this.design.height - height) / 2;
            var qrcodeLayer = QRcodeLayer.create(
                "http://www.a-one.co.jp/",
                x,
                y,
                width,
                height
            );
            // 名前
            qrcodeLayer.name = NameHelper.createLayerName("qrcode", this.design);
            var parent = this.getParentGroupLayer();
            // 新規レイヤー作成コマンド呼び出し
            this.$emit("doCommand", "newLayer", {
                newLayer: qrcodeLayer,
                parent: parent
            });
            } else if (type == "barcode") {
            // バーコード作成
            var width = Math.min(this.design.width / 2, this.design.height / 2);
            var height = width;
            // バーコードのサイズはJIS規定サイズを確保する
            width = Math.max(width, Const.BARCODE_JAN_MIN_WIDTH);
            height = Math.max(height, Const.BARCODE_JAN_MIN_HEIGHT);
            var x = (this.design.width - width) / 2;
            var y = (this.design.height - height) / 2;
            var barcodeLayer = BarcodeLayer.create(
                0,
                "4912345678904",
                x,
                y,
                width,
                height
            );
            // 名前
            barcodeLayer.name = NameHelper.createLayerName("barcode", this.design);
            var parent = this.getParentGroupLayer();
            // 新規レイヤー作成コマンド呼び出し
            this.$emit("doCommand", "newLayer", {
                newLayer: barcodeLayer,
                parent: parent
            });
        }
    }

    // 表設定が行われた
    private onSetTable(
        type: string,
        row: number = 1,
        column: number = 1,
        year: number = 2018,
        month: number = 12,
        startDay: string = "sunday"
    ) {
        if (type == "table") {
            // 表作成
            var width = Math.min(this.design.width / 2, this.design.height / 2);
            var height = width;
            var x = (this.design.width - width) / 2;
            var y = (this.design.height - height) / 2;
            var layer = TableLayer.create(x, y, width, height, row, column);
            // 名前
            layer.name = NameHelper.createLayerName("table", this.design);
            var parent = this.getParentGroupLayer();
            // 新規レイヤー作成コマンド呼び出し
            this.$emit("doCommand", "newLayer", { newLayer: layer, parent: parent });
        } else if (type == "calendar") {
        }
    }

    onClickUndoButton() {
        this.$emit("doCommand", "undo");
    }

    onClickRedoButton() {
        this.$emit("doCommand", "redo");
    }

    // ズーム
    private decreaseZoomScale() {
        // 今のzoomScaleより小さく適切な値を求める
        var newValue = TopController.ZOOM_SCALE_MAX;
        while (newValue >= TopController.ZOOM_SCALE_MIN) {
            if (newValue < this.zoomScale) {
                break;
            }
            newValue -= TopController.ZOOM_SCALE_DELTA;
        }
        if (
            this.zoomScale != newValue &&
            newValue >= TopController.ZOOM_SCALE_MIN
        ) {
            this.onDoCommand("changeZoomScale", {
                scale: newValue,
                isAutoZoomOff: true
            });
        }
    }

    private increaseZoomScale() {
        // 今のzoomScaleより大きく適切な値を求める
        var newValue = TopController.ZOOM_SCALE_MIN;
        while (newValue <= TopController.ZOOM_SCALE_MAX) {
            if (newValue > this.zoomScale) {
                break;
            }
            newValue += TopController.ZOOM_SCALE_DELTA;
        }
        if (
            this.zoomScale != newValue &&
            newValue <= TopController.ZOOM_SCALE_MAX
        ) {
            this.onDoCommand("changeZoomScale", {
                scale: newValue,
                isAutoZoomOff: true
            });
        }
    }

    private changeAutoZoom() {
        this.onDoCommand("changeAutoZoom", { isAutoZoom: !this.isAutoZoom });
    }

    //ズームバーの吹き出し
    speechBaloon = false;

    private get zoomSpeechBalloon() {
        let range = (1000 - this.zoomScale) / 475 + "%";

        // alert(range)

        let distance = "calc(" + this.zoomScale / 10 + "% - 22.5% - " + range + ")";
        var style = {
            position: "absolute",
            left: distance,
            top: "-70%",
            width: "45%",
            height: "70%",
            display: "flex",
            "align-items": "center",
            "justify-content": "center"
        };
        return style;
    }

    progress = 0;
    startPosition = 0;
    scrollWidth = 0;
    scroll(right: boolean): void {
        let topController = this.$refs["top-controller"];
        this.startPosition = (<HTMLElement>topController).scrollLeft;
        this.progress = 0;
        if ((<HTMLElement>topController).clientWidth < 900) {
            // 目視で調整
            this.scrollWidth = (right ? 1 : -1) * 540; // １度目でコピーが左端に来るように調整
        } else {
            this.scrollWidth =
                (right ? 1 : -1) *
                ((<HTMLElement>topController).scrollWidth -
                (<HTMLElement>topController).offsetWidth);
            }
            requestAnimationFrame(this.scrollMove);
    }

    scrollMove() {
        this.progress++;
        let topController = this.$refs["top-controller"];
        let position =
        this.startPosition + Math.sign(this.scrollWidth) * this.progress * 20;
        (<HTMLElement>topController).scrollTo(position, 0);

        if (
            (position < this.startPosition + this.scrollWidth &&
                this.scrollWidth > 0) ||
            (position > this.startPosition + this.scrollWidth && this.scrollWidth < 0)
        ) {
            requestAnimationFrame(this.scrollMove);
        }
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigDarkColor(){
        return this.$store.getters.userConfigColors.darkButtonColorCode;
    }

    // 外でもいい
    // イメージをキャンバスに中央揃えするための位置を得る
    centerImagePosition(image: {width: number, height: number}, canvas: {width: number, height: number}): {x: number, y: number}
    {
        return {
            x: (canvas.width - image.width) / 2,
            y: (canvas.height - image.height) / 2
        };
    }

    //-----画像挿入-----//
    private insertImageItem(image: Image)
    {
        // ImageもRecentImageも共通。

        const imageId = image.id;
        // 最近使った項目に記録されている場合
        if (image.recentUsedAt > 0) {
            this.addRecentImageLayer(image);
            // タイムスタンプを更新する
            image.recentUsedAt = Date.now();
            putRecentImage(image);
            // 情報を画面を更新する
            this.$store.state.data.createImageList('create');
        } else {
            const path = image.imagePath;
            const params = { path };

            RequestHelper.get("path_to_base64", params, (response) => {
                try {
                    var responseData = JSON.parse(response);
                    var data = responseData.data.base64Image;
                    image.imageData = data;
                    // 最近使った項目に追加する
                    image.recentUsedAt = Date.now();
                    putRecentImage(image)
                    this.addImageLayer(path, data);
                } catch(e) {
                    DebugHelper.trace(e);
                }
            }, () => {
                DebugHelper.trace("error");
            });
        }
    }

    addRecentImageLayer(image: Image) {
        const path = image.imagePath;
        const data = image.imageData;
        this.addImageLayer(path, data);
    }

    addImageLayer(path: string, data: string) {
        // 画像サイズ取得
        ImageHelper.getImageSize(data, (size) => {
            // サイズが0の場合は作られない
            if (size.width <= 0 || size.height <= 0) { return; }

            // 白色透明化画像取得
            ImageHelper.createWhiteTransparentImage(data, (whiteTransparentImage) => {
                // 枠の半分のサイズに調整する
                const halfCanvas = {width: this.design.width / 2, height: this.design.height / 2};
                const {width, height} = ImageHelper.fitImageSize(size, halfCanvas);
                const {x, y} = this.centerImagePosition({width, height}, this.design);
                const layer = this.createImageLayer(path, data, whiteTransparentImage, x, y, width, height);
                this.emitNewLayer(layer);
            })
        });
    }

    // ファイル形式を元に作成するレイヤーを決定する
    createImageLayer(path, data, dataTransparent, x, y, width, height) {
        var filename = FileHelper.getFileNameFromUrl(path);
        var ext = FileHelper.getFileExtension(filename);
        var layer;
        if (ext.toLowerCase() == "svg") {
            // ベクター画像レイヤー作成
            layer = VectorImageLayer.create(data, x, y, width, height);
        } else {
            // ラスター画像レイヤー作成
            layer = RasterImageLayer.create(data, x, y, width, height);
        }
        // レイヤーに白色透明を追加
        layer.setWhiteTransparentImage(dataTransparent);
        // 名前
        layer.name = NameHelper.createLayerName("image", this.design);
        return layer;
    }

    // 新規レイヤー作成コマンド呼び出し
    emitNewLayer(newLayer) {
        const parent = this.getParentGroupLayer();
        this.$emit("doCommand", "newLayer", {
            parent,
            newLayer,
        });
    }

    // 画像書き出し
    public exportImage()
    {
        this.isExportVisible = true;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}
